module.exports = __webpack_public_path__ + "static/graphik-regular-45aa950687418a64f0fea5c69e0811c4.woff2";